function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M240.214,401.991h-54.816V9.136c0-2.663-0.855-4.856-2.57-6.567C181.115,0.859,178.928,0,176.261,0h-54.816 c-2.664,0-4.858,0.855-6.567,2.568c-1.711,1.715-2.57,3.905-2.57,6.567v392.855H57.491c-4.186,0-7.042,1.902-8.566,5.708 c-1.524,3.621-0.854,6.95,1.999,9.996l91.36,91.365c2.096,1.707,4.283,2.562,6.567,2.562c2.475,0,4.665-0.855,6.567-2.562 l91.076-91.078c1.908-2.279,2.857-4.571,2.857-6.844c0-2.676-0.855-4.859-2.57-6.584 C245.068,402.847,242.881,401.991,240.214,401.991z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440.062,319.332c-15.609-17.986-35.115-26.977-58.529-26.977c-20.749,0-37.973,6.943-51.679,20.841 c-13.698,13.894-20.55,30.834-20.55,50.819c0,19.226,6.369,35.638,19.13,49.252c12.758,13.605,29.212,20.409,49.389,20.409 c8.385,0,16.427-1.331,24.133-3.997c7.7-2.662,13.562-6.188,17.56-10.561h0.571c-3.046,16.557-9.377,30.402-18.986,41.538 s-22.415,16.7-38.403,16.7c-7.228,0-14.366-1.235-21.402-3.71c-3.046-0.76-5.995-1.807-8.85-3.142l-11.136,32.265 c3.426,1.334,7.419,2.758,11.995,4.295c8.75,3.035,19.034,4.564,30.833,4.564c13.135,0,25.267-2.33,36.401-6.994 c11.137-4.661,20.513-10.887,28.12-18.699c7.618-7.812,14.089-16.882,19.418-27.265c5.328-10.376,9.229-21.228,11.703-32.537 c2.478-11.328,3.72-22.895,3.72-34.694C463.485,361.356,455.673,337.326,440.062,319.332z M413.516,394.288 c-6.659,5.14-14.753,7.71-24.267,7.71c-12.939,0-22.895-3.617-29.845-10.849c-6.947-7.23-10.424-16.279-10.424-27.124 c0-10.841,2.95-19.79,8.85-26.833c5.899-7.046,13.798-10.571,23.698-10.571c11.229,0,21.033,5.041,29.414,15.13 c8.377,10.088,12.559,21.121,12.559,33.119C423.501,382.673,420.182,389.151,413.516,394.288z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.979,60.817c3.426-3.427,5.9-6.374,7.42-8.851l1.995-3.428h0.571v4.57c0,0.948-0.055,2.568-0.144,4.853 c-0.089,2.284-0.144,4.093-0.144,5.424v123.338h-47.671v32.548H454.91v-32.548h-47.109V0h-35.118l-54.816,52.825l23.421,24.554 L358.979,60.817z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgSortNumberAsc = function SvgSortNumberAsc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "511.63px",
    height: "511.63px",
    viewBox: "0 0 511.63 511.63",
    style: {
      enableBackground: "new 0 0 511.63 511.63"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSortNumberAsc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort_number_asc.cf37fc24.svg";
export { ForwardRef as ReactComponent };